import React from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import siteConfig from "../config/siteConfig";
import "../css/policies.scss";

export const policyLinks = [
  { to: "/policies", label: "Policy guide" },
  { to: "/terms-of-sale", label: "Terms of sale" },
  { to: "/orders-payment", label: "Payment & order review" },
  { to: "/cancellations", label: "Cancellations" },
  { to: "/shipping", label: "Shipping & customs" },
  { to: "/delivery-issues", label: "Parcel problems" },
  { to: "/returns", label: "Returns & refunds" },
  { to: "/limited-stock", label: "Limited stock" },
  { to: "/offer-codes", label: "Offer codes" },
  { to: "/product-information", label: "Product information" },
  { to: "/product-care", label: "Wear & care" },
  { to: "/privacy", label: "Privacy" },
  { to: "/privacy-choices", label: "Data rights" },
  { to: "/cookies", label: "Device storage" },
  { to: "/terms-of-use", label: "Website rules" },
  { to: "/intellectual-property", label: "Content rights" },
  { to: "/accessibility", label: "Accessibility" },
  { to: "/complaints", label: "Complaints & updates" },
  { to: "/contact-policy", label: "Contact information" },
];

export function PolicyNav({ activePath }) {
  const location = useLocation();
  const currentPath = activePath || location.pathname;

  return (
    <aside className="service-page__nav policy-nav" aria-label="Policy navigation">
      <span>Policy guide</span>
      {policyLinks.map((item) => (
        <Link key={item.to} className={currentPath === item.to ? "is-active" : ""} to={item.to}>
          {item.label}
        </Link>
      ))}
    </aside>
  );
}

function PolicyLayout({ title, eyebrow, notice, toc = [], children, activePath }) {
  return (
    <div className="policy-page">
      <Header />
      <main className="service-page legal-page">
        <PolicyNav activePath={activePath} />
        <article className="legal-page__content">
          <header>
            <span className="eyebrow">{eyebrow || `${siteConfig.brandName} policy`}</span>
            <h1>{title}</h1>
            <p>Current from {siteConfig.policies.lastUpdated}</p>
          </header>
          {notice && <div className="legal-page__notice">{notice}</div>}
          {toc.length > 0 && (
            <nav className="legal-page__toc" aria-label="Sections on this page">
              {toc.map((item) => <a key={item.id} href={`#${item.id}`}>{item.label}</a>)}
            </nav>
          )}
          {children}
        </article>
      </main>
      <Footer />
    </div>
  );
}

export default PolicyLayout;
